<div class="cards-wrapper">
    <div class="row" style="margin-bottom: 85px;">
        <div class=" col-4 pb-4" *ngFor="let card of eventCards" (click)="redirectToEvent(card.id)">
            <app-event-card [event]="card"></app-event-card>
        </div>
    </div>
</div>